import { render, staticRenderFns } from "./AboutRedemption.vue?vue&type=template&id=b35129f6&scoped=true"
import script from "./AboutRedemption.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutRedemption.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AboutRedemption.vue?vue&type=style&index=0&id=b35129f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35129f6",
  null
  
)

export default component.exports